import { generateFormItemName } from ".";
import type { ButtonType, ButtonVariant } from ".";
import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-shared/uikit/Form";
import { Accordion } from "@circle-react-uikit/Accordion";
import {
  FONT_FAMILY_OPTIONS,
  FONT_WEIGHT_OPTIONS,
} from "../../../Text/TextStyles/constants";
import type { FlattenedCssVariables } from "../index";
import { ButtonSliderControl } from "./ButtonSliderControl";

interface TextProps {
  buttonType: ButtonType;
  buttonVariant: ButtonVariant;
  customColors: Record<string, string>;
  flattenedCssVariables: FlattenedCssVariables;
  onAddCustomColor: (color: string) => void;
  themeColors: FlattenedCssVariables;
}

export const Text = ({
  buttonType,
  buttonVariant,
  flattenedCssVariables,
  themeColors,
  customColors,
  onAddCustomColor,
}: TextProps) => {
  if (buttonVariant === "hover") {
    return (
      <div className="px-6 pt-5">
        <Accordion defaultOpen>
          <Accordion.Item
            title={t(
              "builder_ui.theme_configuration.site_styles.button_styles.text",
            )}
          >
            <Form.Item
              isFirstChild
              hideBorder
              hideDescription
              name={generateFormItemName(
                buttonType,
                buttonVariant,
                "text-color",
              )}
              label={t(
                "builder_ui.theme_configuration.site_styles.button_styles.text_color",
              )}
              className="!flex !w-full !items-center !justify-between"
            >
              <Form.ColorPickerV2
                name={generateFormItemName(
                  buttonType,
                  buttonVariant,
                  "text-color",
                )}
                cssVariables={flattenedCssVariables}
                shouldResolveCssVariable
                shouldRenderThemeColors
                themeColors={themeColors}
                customColors={customColors}
                onAddCustomColor={onAddCustomColor}
              />
            </Form.Item>
          </Accordion.Item>
        </Accordion>
      </div>
    );
  }

  return (
    <div className="px-6 pt-5">
      <Accordion defaultOpen>
        <Accordion.Item
          title={t(
            "builder_ui.theme_configuration.site_styles.button_styles.text",
          )}
        >
          <Form.Item
            isFirstChild
            hideBorder
            hideDescription
            name={generateFormItemName(
              buttonType,
              buttonVariant,
              "font-family",
            )}
            label={t(
              "builder_ui.theme_configuration.site_styles.button_styles.font_type",
            )}
          >
            <Form.TextSelect
              name={generateFormItemName(
                buttonType,
                buttonVariant,
                "font-family",
              )}
              options={FONT_FAMILY_OPTIONS}
            />
          </Form.Item>
          <Form.Item
            hideBorder
            hideDescription
            name={generateFormItemName(buttonType, buttonVariant, "text-color")}
            label={t(
              "builder_ui.theme_configuration.site_styles.button_styles.text_color",
            )}
            className="!flex !w-full !items-center !justify-between"
          >
            <Form.ColorPickerV2
              name={generateFormItemName(
                buttonType,
                buttonVariant,
                "text-color",
              )}
              cssVariables={flattenedCssVariables}
              shouldResolveCssVariable
              shouldRenderThemeColors
              themeColors={themeColors}
              customColors={customColors}
              onAddCustomColor={onAddCustomColor}
            />
          </Form.Item>
          <Form.Item
            hideBorder
            hideDescription
            name={generateFormItemName(
              buttonType,
              buttonVariant,
              "font-weight",
            )}
            label={t(
              "builder_ui.theme_configuration.site_styles.button_styles.font_style",
            )}
            className="!flex !w-full !items-center !justify-between"
          >
            <Form.TextSelect
              label={null}
              name={generateFormItemName(
                buttonType,
                buttonVariant,
                "font-weight",
              )}
              options={FONT_WEIGHT_OPTIONS}
            />
          </Form.Item>
          <ButtonSliderControl
            name={generateFormItemName(buttonType, buttonVariant, "font-size")}
            label={t(
              "builder_ui.theme_configuration.site_styles.button_styles.font_size",
            )}
          />
          <ButtonSliderControl
            name={generateFormItemName(
              buttonType,
              buttonVariant,
              "letter-spacing",
            )}
            label={t(
              "builder_ui.theme_configuration.site_styles.button_styles.letter_spacing",
            )}
          />
        </Accordion.Item>
      </Accordion>
    </div>
  );
};
